import { styled, ToggleButtonGroup, toggleButtonGroupClasses } from '@mui/material';

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    [`& .${toggleButtonGroupClasses.grouped}`]: {
        width: 'fit-content',
        minHeight: '56px',
        height: '100%',
        padding: theme.spacing(1.2, 2),
        border: '1px solid #13131340',
        color: '#131313',
        '&.Mui-selected': {
            backgroundColor: '#131313 !important',
            color: 'white',
        },
    },
}));
